import {SearchFormProps} from "../../common/searchForm/SearchForm.props";
import {OptionType} from "../../common/searchForm/constants/Option.type";

export const NoticeSearchFormProps: SearchFormProps = {
    options: [
        {
            type: OptionType.TEXT,
            key: "keyword",
            name: "검색",
            value: "",
            list: [],
            stringList: []
        }
    ],
    onSearch: () => {},
    onUpdate: () => {}
}